import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useLocation, useNavigate } from "react-router-dom";

export default function DialogueBox(props) {
  const {
    title,
    children,
    open,
    setOpen,
    onConfirm,
    onConfirmState,
    confirmText,
    cancelText,
    stayOnPage = false,
  } = props;

  const checkNavigate = () => {
    if (!stayOnPage) {
      navigate("/");
    }
  };
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm(onConfirmState);
            checkNavigate();
          }}
                  sx={{
                      backgroundColor: "#fc925e",
                      color: "white",
                      "&:hover": { backgroundColor: "#e57c46" } // Optional: Darker shade on hover
                  }}        >
          {confirmText}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
          }}
          color="default"
        >
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
